const leaflets = {
    "acquaesapone": {
        "config": {
            "primary-color": "#26b2e7",
            "secondary-color": "#034fa5",
            "tertiary-color": "rgb(99, 44, 56)",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/clientLogo_acqua&sapone.png"),
            "serverPath": "acquaesapone.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino di Acqua & Sapone!",
            "shareFlyerURL": "https://acquaesapone.volantinointerattivo.net?v=124",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "Volantino Interattivo Acque & Sapone",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino.",
            "ogImageMeta": "https://acquaesapone.volantinointerattivo.net/media/images/acquaesapone_fb.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": false,
            "ga_tracking_id": "UA-152069090-17",
            "release_id": "1",
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 20,
            "client_id": 3,
            "signboard_id": 10,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "/media/images/banner.png",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "leaflet"
        },
        "video": {
            "show_only_once": true,
            "mandatory_seconds": 4,
            "videos": [
                {
                    page: 1,
                    url: "/media/video/uno.mp4",
                    item_id: "185218"
                },
                {
                    page: 6,
                    url: "/media/video/due.mp4",
                    item_id: "185218"
                },
            ],
        },
        "leaflet": {
            "name": "Demo Acqua e sapone",
            "code": "124",
            "id_campaign": "124",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/Indice_acquaesapone_P1RbLoJ.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 30.094923828844347,
                            "left": 8.787217242248335,
                            "width": 80.93182681277808,
                            "height": 7.728551886287391
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 37.688445580007375,
                            "left": 9.015097667112768,
                            "width": 80.93182681277808,
                            "height": 7.728551886287391
                        }
                    },
                    {
                        "page": 7,
                        "blueprint": {
                            "top": 45.63945763068567,
                            "left": 8.649626755422696,
                            "width": 80.93182681277808,
                            "height": 7.728551886287391
                        }
                    },
                    {
                        "page": 8,
                        "blueprint": {
                            "top": 53.36957909557164,
                            "left": 8.94992108201822,
                            "width": 80.93182681277808,
                            "height": 7.728551886287391
                        }
                    },
                    {
                        "page": 14,
                        "blueprint": {
                            "top": 61.21886853491872,
                            "left": 8.809431595001394,
                            "width": 80.93182681277808,
                            "height": 7.728551886287391
                        }
                    },
                    {
                        "page": 16,
                        "blueprint": {
                            "top": 69.2057249826254,
                            "left": 8.629354121767244,
                            "width": 80.93182681277808,
                            "height": 7.728551886287391
                        }
                    },
                    {
                        "page": -1,
                        "type": "url",
                        "url": "https://volantinointerattivo.net",
                        "target": "_blank",
                        "blueprint": {
                            "top": 7.59493670886076,
                            "left": 61.723899939722735,
                            "width": 29.9,
                            "height": 8.571428571428573
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Extra",
                        "Pavimenti",
                        "Bucato",
                        "Superfici"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Intima",
                        "Viso",
                        "Corpo",
                        "Capelli"
                    ]
                },
                {
                    "category_name": "Casa e Cucina",
                    "subcategories": [
                        "Altro",
                        "Stoviglie"
                    ]
                },
                {
                    "category_name": "Pet",
                    "subcategories": [
                        "Food"
                    ]
                },
                {
                    "category_name": "Prima infanzia",
                    "subcategories": [
                        "Puericultura"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_1_V0nsgsr.jpg",
                    "products": [
                        {
                            "item_id": "cstm09785625",
                            "field1": "REGINA rotoloni",
                            "field2": "carta igienica 12 rotoli",
                            "field3": "",
                            "field4": "",
                            "description": "REGINA rotoloni carta igienica 12 rotoli",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 35.50749231557377,
                                "left": 3.037589651639346,
                                "width": 49.84022797131148,
                                "height": 43.41492699795083
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/36806-fancybox_default_xu9OiFx.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_ppuRPHV_3R8QUxI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/video/Rotoloni_Regina.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78381942",
                            "field1": "CAREFREE proteggi slip",
                            "field2": "cotton 44 pezzi/",
                            "field3": "flexicomfort 40 pezzi/",
                            "field4": "3d comfort 40+6 pezzi",
                            "description": "CAREFREE proteggi slip cotton 44 pezzi/ flexicomfort 40 pezzi/ 3d comfort 40+6 pezzi",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "cotton 44 pezzi",
                                "flexicomfort 40 pezzi",
                                "3d comfort 40+6 pezzi"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 35.96055327868852,
                                "left": 50.15977202868852,
                                "width": 49.84022797131148,
                                "height": 43.41492699795083
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/flexicomfort_softpack_40_it_R0VimIa.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cotton_senza_profumo_44_it_w680qVa.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_JPQ8btX_kSh6uCC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.jnjconsumer.it/carefree"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_2_yuCGY0e.jpg",
                    "products": [
                        {
                            "item_id": "cstm39497407",
                            "field1": "clean twist mop ergo",
                            "field2": "set lavapavimenti",
                            "field3": "",
                            "field4": "",
                            "description": "clean twist mop ergo set lavapavimenti",
                            "grammage": null,
                            "price": "19.90",
                            "price_label": "€ 19,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 34.09227715163935,
                                "left": 0.0,
                                "width": 49.58167904713114,
                                "height": 25.25806864754098
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/clean-twist-mop_opnUdhm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_KcPuBUK_I3hyJDT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "Set Lavapavimenti",
                                    "data": {
                                        "specifiche": "sistema per strizzaggio, secchio pavimenti 20 lt, setaccio, anti-spruzzo, panno di rivestimento super soft",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/lV3AVUF29O/images/clean-twist-mop.jpg"
                                        ]
                                    }
                                }
                            ],
                            "related": ["cstm80950670", "cstm58836551"]
                        },
                        {
                            "item_id": "cstm44609869",
                            "field1": "dixan lavatrice",
                            "field2": "2x30 caps",
                            "field3": "",
                            "field4": "",
                            "description": "dixan lavatrice 2x30 caps",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 34.09227715163935,
                                "left": 49.58167904713114,
                                "width": 13.997342469262303,
                                "height": 26.380315061475414
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dixan-it_caps-classic_mini-teaser_7qAnYVj.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dixan-it_discs-classic_mini-teaser_PeXKfzq.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_Ra9fBb0_EnOgGUv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm53055072"]
                        },
                        {
                            "item_id": "cstm53055072",
                            "field1": "dixan lavatrice",
                            "field2": "4x19 lavaggi",
                            "field3": "",
                            "field4": "",
                            "description": "dixan lavatrice 4x19 lavaggi",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 34.09227715163935,
                                "left": 58.37234246926229,
                                "width": 13.997342469262303,
                                "height": 26.380315061475414
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dixan-it_gels-classico_mini-teaser_RLnlm8K.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dixan-it_gels-lavender_mini-teaser_WCZEcyK.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dixan-it_gels-multicolor_mini-teaser_dQQr2ke.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_SWu9gig_eIaN3Dq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm44609869"]
                        },
                        {
                            "item_id": "cstm37226921",
                            "field1": "L'acchiappacolore 2x40 fogli",
                            "field2": "Colleziona 3 prove d’acquisto di l'Acchiappacolore per una spesa minima totale di €10 ",
                            "field3": "Ricevi sempre un set di 2 asciugamani Pantone",
                            "field4": "",
                            "description": "L'acchiappacolore 2x40 fogli Colleziona 3 prove d’acquisto di l'Acchiappacolore per una spesa minima totale di €10  Ricevi sempre un set di 2 asciugamani Pantone",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 33.785619047456144,
                                "left": 69.98959160075535,
                                "width": 27.506234776540136,
                                "height": 26.804484591806013
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/grey-it_complete-action-navi-teaser_600x450_9nNq8i9.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_Iawl4wt_xuIZ8V2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/video/acchiappacolori.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11108029",
                            "field1": "HUGGIES pannolini ",
                            "field2": "assorti pacco triplo",
                            "field3": "",
                            "field4": "",
                            "description": "HUGGIES pannolini  assorti pacco triplo",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 62.865650614754095,
                                "left": 0.0,
                                "width": 28.21273053278689,
                                "height": 27.492955942622952
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/aee0c624-618465_1qQlkS5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_1aKhs8j_q2pBlQD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.huggies.it/pannolini/ultracomfort/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm57659483",
                            "field1": "HUGGIES mutandina",
                            "field2": "pannolini assorti pacco triplo",
                            "field3": "",
                            "field4": "",
                            "description": "HUGGIES mutandina pannolini assorti pacco triplo",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 62.5638767930328,
                                "left": 21.449955174180324,
                                "width": 28.21273053278689,
                                "height": 27.492955942622952
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/hug2658841_NnBV73k.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_X0TcmEJ_6cEGeJA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm57821449",
                            "field1": "LOCTITE SUPER ATTAK",
                            "field2": "easy brush 5g",
                            "field3": "",
                            "field4": "",
                            "description": "LOCTITE SUPER ATTAK easy brush 5g",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 62.5638767930328,
                                "left": 48.67123463114755,
                                "width": 25.38310066598361,
                                "height": 27.492955942622952
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/adesivo-super-attak-easy-brush-loctite-5-g-2048077_5FYOuoi.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_LWsz6iq_WJ0m2a9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Loctite Super Attak Easy Brush - Adesivo istantaneo universale con pratico pennello applicatore ",
                                    "data": {
                                        "titolo": "Loctite Super Attak Easy Brush - Adesivo istantaneo universale con pratico pennello applicatore ",
                                        "testo": "Incollare non è mai stato così facile, grazie a Super Attak Easy Brush con pratico applicatore a pennello! Per i lavori di precisione il pennello permette una facile applicazione anche nei particolari più minuti, consentendo di dosare perfettamente la quantità di colla desiderata e di stenderla perfettamente su ogni tipo di superficie senza sbavatura, che si tratti di un oggetto molto piccolo o del manico di una tazza! Garantisce un'elevata precisione ed un'applicazione facile, che eviterà quei noiosi problemi di incollaggio delle dita. Niente di più semplice! La sua formula liquida offre una tripla resistenza: alle alte temperature, all'acqua e agli shock da urto.\n\n \n\nLa colla trasparente incolla in pochi secondi quasi tutti i materiali e la forma del barattolo offre stabilità e praticità nell'apertura e nella chiusura. La colla Loctite Super Attak Easy Brush è ideale su molti materiali, come gomma, metallo, porcellana, pelle, legno e plastica*.\n\n*Non adatta a PE, PP, PTFE, gomma siliconica, vetro (fonte: loctite-consumer.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/lV3AVUF29O/images/packshot-product-it-loctite-superattak-easybrush.jpeg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59936778",
                            "field1": "PRITT colla stick",
                            "field2": "11g 3+2 GRATIS",
                            "field3": "",
                            "field4": "",
                            "description": "PRITT colla stick 11g 3+2 GRATIS",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 62.92008196721312,
                                "left": 69.21426741803279,
                                "width": 25.38310066598361,
                                "height": 27.492955942622952
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/Pritt-Colla-Stick-11g-32-pezzi-0_AtyPvSG.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_gtj2WJG_kGDGUU2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79836559",
                            "field1": "Concorso",
                            "field2": "Oltre la spesa",
                            "field3": "",
                            "field4": "",
                            "description": "Concorso Oltre la spesa",
                            "grammage": null,
                            "price": "0.00",
                            "price_label": "",
                            "equivalence": null,
                            "quantity_step": null,
                            "grocery_label": "",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": true,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 0,
                                "left": 0,
                                "width": 100,
                                "height": 33.92441860465116
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_qHKOmXA_QGP0JnP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "http://mediastarcorporate.net/acquaesapone/concorso.php?ref=1"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_3_BPGLmxL.jpg",
                    "products": [
                        {
                            "item_id": "cstm04086757",
                            "field1": "NEUTROMED detergente intimo",
                            "field2": "200ml",
                            "field3": "",
                            "field4": "",
                            "description": "NEUTROMED detergente intimo 200ml",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Delicatezza",
                                "Freschezza",
                                "Purezza micellare",
                                "Lenitivo",
                                "Tollerabilità",
                                "Attivo for men"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 4.482421875000003,
                                "left": 49.64491547131148,
                                "width": 50.35508452868852,
                                "height": 27.90279200819672
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/NM_RL19_Intimo_200_ATTIVO_FOR_MEN_M6BAN0T.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/NM_RL19_Intimo_200_DELICATEZZA_iBOOJr7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/NM_RL19_Intimo_200_FRESCHEZZA_OvO5VkW.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/NM_RL19_Intimo_200_LENITIVO_hKwOUX9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/NM_RL19_Intimo_200_PUREZZA_MICELLARE_zwQaRS2.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/NM_RL19_Intimo_200_TOLLERABILITA_oLLmiXb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_4Z3FUWd_0t90m75.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm95882157",
                            "field1": "INTESA",
                            "field2": "schiuma da barba 300 ml",
                            "field3": "",
                            "field4": "",
                            "description": "INTESA schiuma da barba 300 ml",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 33.60283879950495,
                                "left": 0.0,
                                "width": 50.355084528688536,
                                "height": 27.902792008196727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/Schiuma-Barba-Olio-Avocado-Intesa_RkubJa5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_PF0oVAl_v5JVuQ1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/video/Intesa.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm15999519",
                            "field1": "LYCIA deodorante",
                            "field2": "vapo 75 ml",
                            "field3": "",
                            "field4": "",
                            "description": "LYCIA deodorante vapo 75 ml",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Evolution",
                                "Zen",
                                "Energy"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 33.694210241336634,
                                "left": 49.644915471311464,
                                "width": 50.355084528688536,
                                "height": 27.902792008196727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/800090-deo-vapo-lycia_evolution_lSZkwVn.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/800102-deo-vapo-lycia_nature-zeninfusion_RuLJXQq.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/800124-deo-vapo-lycia_fresh_energy_T6rvpcb.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_AJjPDXw_3qvwn3G.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73111799",
                            "field1": "ACQUA ALLE ROSE",
                            "field2": "sensitive crema antirughe 50ml",
                            "field3": "",
                            "field4": "",
                            "description": "ACQUA ALLE ROSE sensitive crema antirughe 50ml",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 62.18227877475248,
                                "left": 0.0,
                                "width": 50.355084528688536,
                                "height": 27.902792008196727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/Acqua_alle_Rose-Antirughe-Crema_Antirughe_Sensitive_per_pelli_delic_zHL5Ju1.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_WlAqHjg_uxxuXp9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "LA FORMULA",
                                        "testo": "La sua formula delicata, con il 95% di ingredienti di origine naturale, è appositamente studiata per le pelli sensibili.\nIl Collagene Vegetale, ingrediente attivo della nuova Antirughe Sensitive, replica l’azione del collagene naturalmente contenuto nella pelle e, idratando intensamente, la rimpolpa e ne distende le rughe.\nContiene inoltre estratto di Rosa di origine 100% naturale che idrata e lenisce la pelle, aiutando a migliorarne il metabolismo.\nLa sua formula è studiata per minimizzare il rischio di allergie e arrossamenti e aiutare a ridurre le sensazioni di fastidio come la pelle che tira.\nTexture cremosa a rapido assorbimento.\n(Fonte: https://www.acquaallerose.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/lV3AVUF29O/images/antirughe-sensitive-crema-viso-pelli-delicate-50-ml-122377.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53210672",
                            "field1": "L'OREAL PARIS ELVIVE",
                            "field2": "shampoo 250 ml",
                            "field3": "",
                            "field4": "",
                            "description": "L'OREAL PARIS ELVIVE shampoo 250 ml",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Capelli",
                            "blueprint": {
                                "top": 61.65967280321784,
                                "left": 49.64491547131146,
                                "width": 50.355084528688536,
                                "height": 27.902792008196727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/Shampoo_Olio_Straordinario_Jojoba_250ml_PTmXM1X.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/Shampoo_Olio_Straordinario_Cocco_250ml_SwgqXz5.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_vE3uZjR_Mre2neq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/video/Elvive.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_4_03XQoip.jpg",
                    "products": [
                        {
                            "item_id": "cstm60744245",
                            "field1": "SOLE lavatrice",
                            "field2": "3x37/40 lavaggi",
                            "field3": "",
                            "field4": "",
                            "description": "SOLE lavatrice 3x37/40 lavaggi",
                            "grammage": null,
                            "price": "7.50",
                            "price_label": "€ 7,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 8.286181157178227,
                                "left": 7.723545792079208,
                                "width": 26.9272534643321,
                                "height": 19.97668201438485
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/sole_hlPM5RI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_4dGmgW0_Swp20o1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm19040782", "cstm44389040", "cstm16770995", "cstm11137464"]
                        },
                        {
                            "item_id": "cstm19040782",
                            "field1": "SOLE lavatrice in polvere",
                            "field2": "23 misurini",
                            "field3": "",
                            "field4": "",
                            "description": "SOLE lavatrice in polvere 23 misurini",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 8.194326268564366,
                                "left": 33.31480120668318,
                                "width": 13.139351236609327,
                                "height": 19.577531339695774
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/solePolvere_8gMbXio.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_5LrII4J_GdJawzr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm60744245", "cstm44389040", "cstm16770995", "cstm11137464"]
                        },
                        {
                            "item_id": "cstm44389040",
                            "field1": "SOLE lavatrice 14/15 caps",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "SOLE lavatrice 14/15 caps",
                            "grammage": null,
                            "price": "2.50",
                            "price_label": "€ 2,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 7.55279238861387,
                                "left": 47.13074334777227,
                                "width": 18.16284675022319,
                                "height": 19.060066915374946
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/solePack_c3lzwhe.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_CFMw7T0_lLIpjEG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm60744245", "cstm19040782", "cstm16770995", "cstm11137464"]
                        },
                        {
                            "item_id": "cstm16770995",
                            "field1": "SOLE bucato 16 lavaggi",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "SOLE bucato 16 lavaggi",
                            "grammage": null,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 8.015450959158425,
                                "left": 66.77563085990033,
                                "width": 9.153604649131154,
                                "height": 19.060066915374946
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/soleBianco_Isi3KAJ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_4w6C6xk_maDpbqM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm60744245", "cstm19040782", "cstm44389040", "cstm11137464"]
                        },
                        {
                            "item_id": "cstm11137464",
                            "field1": "SOLE cura lavatrice",
                            "field2": "- express 250 ml",
                            "field3": "- 2x250 ml",
                            "field4": "",
                            "description": "SOLE cura lavatrice - express 250 ml - 2x250 ml",
                            "grammage": null,
                            "price": "3.20",
                            "price_label": "€ 3,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "express 250 ml",
                                "2x250 ml"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 8.102954826732681,
                                "left": 75.64201732673268,
                                "width": 18.16284675022319,
                                "height": 19.060066915374946
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/lavatrice_s7P4orz.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_UKiiDIo_AdPj9mF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm60744245", "cstm19040782", "cstm44389040", "cstm16770995"]
                        },
                        {
                            "item_id": "cstm09967515",
                            "field1": "LIP WOOLITE bucato a mano",
                            "field2": "e lavatrice 25 lavaggi",
                            "field3": "",
                            "field4": "",
                            "description": "LIP WOOLITE bucato a mano e lavatrice 25 lavaggi",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 28.922590501237632,
                                "left": 7.912090037128713,
                                "width": 27.21152017225289,
                                "height": 19.852919638147227
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/lip-woolite-detersivo-liquido-bucato-a-mano-e-lavatrice-rosa-lana-e-_w84xs02.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_sWuLtpP_LhhRyxk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71616109",
                            "field1": "AMUCHINA additivo bucato",
                            "field2": "- igienizzante 1000 ml",
                            "field3": "- disinfettante in polvere 500g",
                            "field4": "",
                            "description": "AMUCHINA additivo bucato - igienizzante 1000 ml - disinfettante in polvere 500g",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "igienizzante 1000 ml",
                                "disinfettante in polvere 500g"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 49.549814356435654,
                                "left": 7.723545792079208,
                                "width": 27.21152017225289,
                                "height": 19.852919638147224
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/amuchina_RQ5CgYX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_mHre8m7_L1omsRM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Modalità  d'uso",
                                        "testo": "Amuchina additivo liquido igienizzante con ammorbidente si usa sempre nell’ultimo risciacquo.\nIn lavatrice:\nversare 1 tappo e mezzo (ca. 60ml) nella vaschetta dell’ammorbidente per un carico standard da 4,5 kg di bucato.\nA mano:\nversare 1 tappo e mezzo (ca. 60ml) ogni 10 litri di acqua fredda, mescolare bene ed effettuare il risciacquo. Non usare il prodotto direttamente sul bucato.",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/lV3AVUF29O/images/amuchina_RQ5CgYX.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm22617132",
                            "field1": "DERMIS linea verde",
                            "field2": "lavatrice 2000 ml",
                            "field3": "",
                            "field4": "",
                            "description": "DERMIS linea verde lavatrice 2000 ml",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 69.84280011775839,
                                "left": 7.1425734719029,
                                "width": 30.963137248578896,
                                "height": 20.37038406246805
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dermis_6CbPA8z.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_hB5Duzb_9WDn180.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12533357",
                            "field1": "DERMIS linea verde",
                            "field2": "eco candeggina 900 ml",
                            "field3": "",
                            "field4": "",
                            "description": "DERMIS linea verde eco candeggina 900 ml",
                            "grammage": null,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 69.93386448019801,
                                "left": 37.65534152031592,
                                "width": 26.047225217531025,
                                "height": 19.852919638147227
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dermisa_9gDp9hN.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_oTuRnNB_BQme6Hy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm34319376",
                            "field1": "CALGON anticalcare",
                            "field2": "- power polvere 17 misurini",
                            "field3": "- powerball 15 tabs  - power gel 15 lavaggi",
                            "field4": "- hygiene + gel 15 lavaggi",
                            "description": "CALGON anticalcare - power polvere 17 misurini - powerball 15 tabs  - power gel 15 lavaggi - hygiene + gel 15 lavaggi",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "power polvere 17 misurini",
                                "powerball 15 tabs",
                                "power gel 15 lavaggi",
                                "hygiene + gel 15 lavaggi"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 30.041383044554454,
                                "left": 65.29093827351485,
                                "width": 27.236908261138616,
                                "height": 39.6817953279703
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/calgon_MjbJazC.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_rQW7IZm_FzJljQE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12992357",
                            "field1": "COCCOLATEVI",
                            "field2": "profuma biancheria 250 ml ",
                            "field3": "",
                            "field4": "",
                            "description": "COCCOLATEVI profuma biancheria 250 ml ",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 69.80101330445545,
                                "left": 65.19956683168317,
                                "width": 27.236908261138616,
                                "height": 19.999226485148515
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/glicine_sLI34wZ.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_MZU1SMQ_NMxLyxi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_5_ycSCzUF.jpg",
                    "products": [
                        {
                            "item_id": "cstm57781889",
                            "field1": "REGINA asciugoni",
                            "field2": "carta casa 2 rotoli",
                            "field3": "",
                            "field4": "",
                            "description": "REGINA asciugoni carta casa 2 rotoli",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 9.575146967821782,
                                "left": 7.5591738861386135,
                                "width": 26.956992574257427,
                                "height": 18.82590114480198
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/regina_CeQyig9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_jlSfzZF_kA9Lr54.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71779513",
                            "field1": "FOXY gran tavola scozzesi",
                            "field2": "tovaglioli 2 veli",
                            "field3": "33x33 cm 43 pezzi",
                            "field4": "",
                            "description": "FOXY gran tavola scozzesi tovaglioli 2 veli 33x33 cm 43 pezzi",
                            "grammage": null,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 9.300549195544555,
                                "left": 35.0431234529703,
                                "width": 16.59334390470297,
                                "height": 18.82590114480198
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/FOXY-GRAN-TAVOLA-43-TOVAGLIOLI-2-VELI-extra-big-281-749_AoSie77.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_STVrNAy_nfE4Qu5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32582509",
                            "field1": "FOXY trapuntati",
                            "field2": "tovaglioli 2 veli 40x40 cm",
                            "field3": "45 pezzi",
                            "field4": "",
                            "description": "FOXY trapuntati tovaglioli 2 veli 40x40 cm 45 pezzi",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 9.121673886138613,
                                "left": 52.415783570544555,
                                "width": 16.59334390470297,
                                "height": 18.82590114480198
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/trapuntati_BjbT08z.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_eKfNwHq_FhDrFwe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm90501453",
                            "field1": "LIMONELLO piatti",
                            "field2": "- 1000 ml",
                            "field3": "- concentrato 500 ml",
                            "field4": "",
                            "description": "LIMONELLO piatti - 1000 ml - concentrato 500 ml",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 8.200224319306932,
                                "left": 69.54575340346535,
                                "width": 23.171120823019802,
                                "height": 19.47273167520301
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/limonello-piatti-1250-ml_5u9Rmdp.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_Y5x9EKp_YWnSL0l.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64648122",
                            "field1": "FRIO cartaforno antiaderente",
                            "field2": "33x38 cm 50 fogli",
                            "field3": "",
                            "field4": "",
                            "description": "FRIO cartaforno antiaderente 33x38 cm 50 fogli",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 28.48323406559406,
                                "left": 6.944229579207921,
                                "width": 28.28212020420792,
                                "height": 16.620900371287124
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cartaforno_w4UWBmN",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_qCw77zo_NdUOfly.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82639129",
                            "field1": "FRIO alluminio 20 m",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "FRIO alluminio 20 m",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 43.45799814356436,
                                "left": 6.8523746905940595,
                                "width": 28.28212020420792,
                                "height": 13.645479931442365
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/alluminio_44UaF8V.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_4nChilj_QnBm2ZV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm62824645",
                            "field1": "FRIO pellicola 30 m",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "FRIO pellicola 30 m",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 56.18280089727723,
                                "left": 7.164197865099009,
                                "width": 28.314027691831676,
                                "height": 13.1385875438692
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/pellicola_d0QNtMi",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_FN9ULyi_JhSSYqu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88479197",
                            "field1": "CUKI sacchetti apri e chiudi",
                            "field2": "ermetici assortiti",
                            "field3": "",
                            "field4": "",
                            "description": "CUKI sacchetti apri e chiudi ermetici assortiti",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.48048808787127,
                                "left": 7.219310798267326,
                                "width": 20.095432394801975,
                                "height": 21.02606745049505
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cuki_A2oey4t.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_SNg9Cvy_D0yzXjg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Il prodotto e le sue caratteristiche",
                                        "testo": "Cuki Sacchetti Apri & Chiudi risolvono con praticità la necessità di proteggere i tuoi cibi durante la congelazione, la conservazione nel frigorifero o più semplicemente l'asporto.\nIl pratico sistema di chiusura con cursore ti permette di aprire e chiudere facilmente i sacchetti, garantendo una tenuta ermetica e un utilizzo ripetuto.\nIl fondo a soffietto ti consente di riporre i cibi con maggiore facilità: durante il riempimento il sacchetto rimane in piedi da solo e viene sfruttata al meglio la sua capienza.\nLo speciale film in polietilene con cui sono realizzati i sacchetti li rende ultra-resistenti e impermeabili.\n (Fonte: cuki.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/lV3AVUF29O/images/5ad4ba81afa91_5ad47ff67f79d_SACCHETTI_apriechiudi.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24865081",
                            "field1": "ARIX puligienico",
                            "field2": "panno multiuso ",
                            "field3": "36x38 cm 3 pezzi",
                            "field4": "",
                            "description": "ARIX puligienico panno multiuso  36x38 cm 3 pezzi",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 70.28876115639291,
                                "left": 28.84456694580831,
                                "width": 20.904698532097058,
                                "height": 19.60304028361277
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/puligenico_VTFLwxA.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_56NE8o8_zlclwK4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60607635",
                            "field1": "ARIX pratico",
                            "field2": "panno multiuso",
                            "field3": "35x37 cm",
                            "field4": "",
                            "description": "ARIX pratico panno multiuso 35x37 cm",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 68.56315970672375,
                                "left": 51.2022449683493,
                                "width": 20.904698532097058,
                                "height": 21.02606745049505
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/arix_UYHTFvG.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_ctHpBBN_4Nj2ANI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18925423",
                            "field1": "ARIX asciugatutto",
                            "field2": "panno multiuso 35x29 cm",
                            "field3": "",
                            "field4": "",
                            "description": "ARIX asciugatutto panno multiuso 35x29 cm",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 69.37322630508437,
                                "left": 71.8325280113821,
                                "width": 20.904698532097058,
                                "height": 21.02606745049505
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/asciugatutto_wiUCKw7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_SBYdq5d_wN6mFE0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm15867546",
                            "field1": "DEPRUEL",
                            "field2": "sale lavastoviglie 1 kg",
                            "field3": "",
                            "field4": "",
                            "description": "DEPRUEL sale lavastoviglie 1 kg",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 52.791675331723745,
                                "left": 64.57314660769356,
                                "width": 28.22731635996591,
                                "height": 16.18647984803603
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/sale_0347jy0.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_32lAxPW_OHGb8BK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59775042",
                            "field1": "CASACHIARA",
                            "field2": "- brillante 500 ml",
                            "field3": "- curalavastoviglie 250 ml",
                            "field4": "",
                            "description": "CASACHIARA - brillante 500 ml - curalavastoviglie 250 ml",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "curalavastoviglie 250 ml",
                                "brillante 500 ml"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 27.01923040344505,
                                "left": 63.84626065100736,
                                "width": 13.767854980586556,
                                "height": 25.88468283054775
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/casachiara-brillantante-500ml-neutro_K4x6LkT.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_6PiTcCK_NNkD2Tq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm04445166",
                            "field1": "CASACHIARA 3in1",
                            "field2": "lavastoviglie",
                            "field3": "- eco gel 750 ml",
                            "field4": "- 25 pastiglie",
                            "description": "CASACHIARA 3in1 lavastoviglie - eco gel 750 ml - 25 pastiglie",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "eco gel 750 ml",
                                "25 pastiglie"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 28.022449396006504,
                                "left": 76.28069015277553,
                                "width": 16.61390931435111,
                                "height": 24.59102176974568
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/CASACHIARA-ECOGEL-LAVASTOVIGLIE_1fPm1PO.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_hKKhmLu_1ImAIqW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_6_1QXFrrt.jpg",
                    "products": [
                        {
                            "item_id": "cstm80950670",
                            "field1": "MASTRO LINDO",
                            "field2": "pavimenti 950ml",
                            "field3": "Bagno spray 500ml",
                            "field4": "",
                            "description": "MASTRO LINDO pavimenti 950ml Bagno spray 500ml",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 25.74385510996119,
                                "left": 7.5032341526520065,
                                "width": 12.160413971539457,
                                "height": 20.957309184993527
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/lindo_tHCe3eV.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_N6QtrTK_1ERNqb6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm39497407", "cstm75174747"]
                        },
                        {
                            "item_id": "cstm52669346",
                            "field1": "VIAKAL",
                            "field2": "3in1 wc gel 750ml",
                            "field3": "",
                            "field4": "",
                            "description": "VIAKAL 3in1 wc gel 750ml",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 26.13195342820181,
                                "left": 19.66364812419146,
                                "width": 7.761966364812421,
                                "height": 20.698576972833113
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/IMMAGINO_IMMAGINO_EAN8001841651323_70_renditions_600x600_QsOYVV8.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_vl23O2t_djjSK9I.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59583375",
                            "field1": "VIAKAL",
                            "field2": "anticalcare 515ml",
                            "field3": "spray, crema",
                            "field4": "",
                            "description": "VIAKAL anticalcare 515ml spray, crema",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 26.778783958602844,
                                "left": 27.037516170763258,
                                "width": 7.761966364812421,
                                "height": 22.63906856403622
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/viakal_58yBLwN.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/vi_zF8AjeF.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_9z6JgK9_Zsv9Wdo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm34161637",
                            "field1": "Electric",
                            "field2": "ricarica",
                            "field3": "",
                            "field4": "",
                            "description": "Electric ricarica",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 46.83053040103493,
                                "left": 7.115135834411384,
                                "width": 6.985769728331179,
                                "height": 17.205692108667524
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/26413_1_tKRfV25.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_jUbjzsV_iNvOrcg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71908302",
                            "field1": "3 VOLUTION",
                            "field2": "ricarica",
                            "field3": "",
                            "field4": "",
                            "description": "3 VOLUTION ricarica",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 46.95989650711513,
                                "left": 14.359637774902977,
                                "width": 7.6326002587322135,
                                "height": 16.55886157826649
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/6114o-DgNL._AC_SY450__0rpNUD8.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_bkn7glr_uCuE9nP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm50479698",
                            "field1": "Car ricarica",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Car ricarica",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 49.417852522639066,
                                "left": 22.76843467011643,
                                "width": 12.160413971539457,
                                "height": 10.478654592496763
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/big_124021_290004_01_lksihu0mtws3dlih_N0fhDh4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_5FymWrA_rI8eu9N.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35635662",
                            "field1": "xxl duster kit ",
                            "field2": "+ 2 panni",
                            "field3": "",
                            "field4": "",
                            "description": "xxl duster kit  + 2 panni",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 63.38939197930142,
                                "left": 14.877102199223803,
                                "width": 12.54851228978008,
                                "height": 12.67787839586028
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/swiffer_qhFnrxs.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_8zOzYAq_oj8IvZp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08971414",
                            "field1": "duster",
                            "field2": "9 piumini",
                            "field3": "",
                            "field4": "",
                            "description": "duster 9 piumini",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 59.379042690815005,
                                "left": 27.684346701164298,
                                "width": 7.115135834411387,
                                "height": 16.94695989650711
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/lock_DYGbxEr.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_fWdOT4s_XnXyPaW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm58492846",
                            "field1": "kit",
                            "field2": "8+3 ricambi",
                            "field3": "",
                            "field4": "",
                            "description": "kit 8+3 ricambi",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 67.27037516170763,
                                "left": 7.373868046571799,
                                "width": 9.314359637774906,
                                "height": 22.63906856403622
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/swiffer-kit_uTCOBNR.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_paQYiar_kbgzHcG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm31271398",
                            "field1": "Swiffer",
                            "field2": "20 panni",
                            "field3": "",
                            "field4": "",
                            "description": "Swiffer 20 panni",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 76.06727037516171,
                                "left": 16.170763260025875,
                                "width": 9.702457956015529,
                                "height": 13.842173350582144
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/swiffeer_v5qmQU3.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_SPykwGo_X9Qvt7r.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45571000",
                            "field1": "Swiffer",
                            "field2": "Ricambi profumati",
                            "field3": "18 panni",
                            "field4": "",
                            "description": "Swiffer Ricambi profumati 18 panni",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 76.19663648124191,
                                "left": 25.226390685640368,
                                "width": 10.219922380336355,
                                "height": 13.842173350582144
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/81VqaTUGZ5L._AC_SX466__bPshfLS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_FG43hsc_zQvvYIJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19765711",
                            "field1": "Black Mop",
                            "field2": "Kit pavimenti",
                            "field3": "",
                            "field4": "",
                            "description": "Black Mop Kit pavimenti",
                            "grammage": null,
                            "price": "14.90",
                            "price_label": "€ 14,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 7.7619663648124195,
                                "left": 35.70504527813714,
                                "width": 28.33117723156533,
                                "height": 20.4398447606727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/black-mop_MKgiJMq.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_aa9oHdT_OYZKgK3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06002993",
                            "field1": "dry&clean",
                            "field2": "lavavetri",
                            "field3": "aspirante",
                            "field4": "",
                            "description": "dry&clean lavavetri aspirante",
                            "grammage": null,
                            "price": "34.90",
                            "price_label": "€ 34,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 69.85769728331177,
                                "left": 35.70504527813714,
                                "width": 28.33117723156533,
                                "height": 20.4398447606727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/lavavetri_kzt9jGJ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_mOGNYaq_S6jTNW8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm25874534",
                            "field1": "Arix",
                            "field2": "panno pavimenti",
                            "field3": "50x60",
                            "field4": "",
                            "description": "Arix panno pavimenti 50x60",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 7.632600258732212,
                                "left": 63.90685640362225,
                                "width": 28.719275549805953,
                                "height": 20.4398447606727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/arix-panno-pavimenti-strofi-5055cm-350-eur-panni-e-spugne_yTagz5i.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_XiflFCG_1WvpwlU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm58836551",
                            "field1": "Smac",
                            "field2": "Express pavimenti",
                            "field3": "1000ml",
                            "field4": "",
                            "description": "Smac Express pavimenti 1000ml",
                            "grammage": 1000,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 28.460543337645536,
                                "left": 64.5536869340233,
                                "width": 28.201811125485122,
                                "height": 26.26131953428202
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/smac_xVB8DxC.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_ihbZxOA_XuRHc3D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "NOVITÀ SMAC EXPRESS PAVIMENTI",
                                        "testo": "Smac Express Pavimenti Freschezza Intensa garantisce una pulizia profonda e veloce di tutte le superfici.\nRimuove anche lo sporco più ostinato senza risciacquo.\nAsciuga rapidamente e non lascia aloni.\nDona un fresco profumo di pulito di lunga durata.\nAdatto per pavimenti in marmo, piastrelle, pavimenti in gres porcellanato e pavimenti in cotto.\n(Fonte: www.smac-casa.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/lV3AVUF29O/images/SO13151-SMAC_express_PAVIMENTI-BLU_IT_3D-02-e1583237278121.png"
                                        ]
                                    }
                                }
                            ],
                            "related": ["cstm39497407", "cstm80950670"]
                        },
                        {
                            "item_id": "cstm75174747",
                            "field1": "Smac",
                            "field2": "Express",
                            "field3": "650ml",
                            "field4": "",
                            "description": "Smac Express 650ml",
                            "grammage": 650,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 56.27425614489004,
                                "left": 64.29495472186288,
                                "width": 13.583441138421733,
                                "height": 33.247089262613194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/smac_E7uUVhl_rpllFDz.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_hTaoTzX_P7lwFuB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49543242",
                            "field1": "Smac",
                            "field2": "Brilla acciaio",
                            "field3": "crema/spray 500ml",
                            "field4": "",
                            "description": "Smac Brilla acciaio crema/spray 500ml",
                            "grammage": 500,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 57.05045278137128,
                                "left": 79.43078913324709,
                                "width": 13.195342820181112,
                                "height": 33.247089262613194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_OnySVHk_3h7Vkze.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_7_SV5xLrm.jpg",
                    "products": [
                        {
                            "item_id": "cstm58644741",
                            "field1": "Diamant",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Diamant",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 8.372480666210343,
                                "left": 7.61134606019122,
                                "width": 41.73554756338186,
                                "height": 12.305009463975807
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/GOURMET_Diamant_Gatto_Fiocchi_di_Tonno_Naturale_in_Gel_e_con_Orata_8_NeZ1ssx.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_hYIa4KO_T1aP2Kq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63080860",
                            "field1": "Le ghiottonerie",
                            "field2": "4x100g",
                            "field3": "",
                            "field4": "",
                            "description": "Le ghiottonerie 4x100g",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 21.862871927554977,
                                "left": 7.7619663648124195,
                                "width": 17.46442432082794,
                                "height": 16.688227684346703
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/FELIX_Le_GHIOTTONERIE_Gatto_Junior_con_Manzo_e_con_Pollo_4x100g_1_12_BVlKzB0.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_fyA6f8v_MvU8lQF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71346574",
                            "field1": "Secco Gatto",
                            "field2": "800g",
                            "field3": "",
                            "field4": "",
                            "description": "Secco Gatto 800g",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 21.604139715394567,
                                "left": 25.873221216041397,
                                "width": 24.0620957309185,
                                "height": 17.076326002587326
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/07613034643780_C1N2_One_Cat_Turkey_Rice_800g_43736212-min-min_Up3IhUp.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_td1FyOg_H8GihRV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm03237341",
                            "field1": "MIGLIORGATTO STERILIZED 400g",
                            "field2": "Croccantini: Pollo, Manzo, Salmone",
                            "field3": "",
                            "field4": "",
                            "description": "MIGLIORGATTO STERILIZED 400g Croccantini: Pollo, Manzo, Salmone",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pollo ",
                                "Manzo",
                                "Salmone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 39.197930142302724,
                                "left": 7.244501940491591,
                                "width": 21.862871927554977,
                                "height": 16.041397153945667
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/miglior-gatto_brOsTyM.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_qBKsIJT_qaIZaU4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82107604",
                            "field1": "MIGLIORGATTO STERILIZED 100g",
                            "field2": "patè:",
                            "field3": "Pollo e Prosciutto. Manzo, Fegato e Carote. Pesce Azzurro e Gamberetti",
                            "field4": "",
                            "description": "MIGLIORGATTO STERILIZED 100g patè: Pollo e Prosciutto. Manzo, Fegato e Carote. Pesce Azzurro e Gamberetti",
                            "grammage": null,
                            "price": "0.39",
                            "price_label": "€ 0,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pesce Azzurro e Gamberetti",
                                "Pollo e Prosciutto",
                                "Manzo",
                                " Fegato e Carote"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 39.197930142302724,
                                "left": 29.883570504527814,
                                "width": 21.345407503234153,
                                "height": 16.041397153945667
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/pate_kzFCcqZ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_4OodtFK_XQIZe4K.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91546123",
                            "field1": "CATSAN hygiene plus",
                            "field2": "lettiera 10L",
                            "field3": "",
                            "field4": "",
                            "description": "CATSAN hygiene plus lettiera 10L",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 55.49805950840881,
                                "left": 7.115135834411384,
                                "width": 26.520051746442434,
                                "height": 15.653298835705046
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/catsan_PArh4Lk.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_WtndAEV_5hj6rEZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm25756625",
                            "field1": "WHISKAS pranzetti",
                            "field2": "6X50 g",
                            "field3": "",
                            "field4": "",
                            "description": "WHISKAS pranzetti 6X50 g",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 55.368693402328596,
                                "left": 33.89391979301423,
                                "width": 17.46442432082794,
                                "height": 17.33505821474774
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/wiskas_l19YLNW.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_6xqtHAT_Wi3PlGy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54476145",
                            "field1": "SHEBA",
                            "field2": "creazioni speciali",
                            "field3": "in salsa 85g",
                            "field4": "",
                            "description": "SHEBA creazioni speciali in salsa 85g",
                            "grammage": 85,
                            "price": "0.49",
                            "price_label": "€ 0,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 73.35058214747737,
                                "left": 33.76455368693402,
                                "width": 17.46442432082794,
                                "height": 16.558861578266495
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/thumb_tacchino-e-verdure-in-salsa-delicata-vaschetta-85g-63620854201_U9GsBcS.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_lXTEyW8_YMVrlIK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm36499483",
                            "field1": "Secco cane",
                            "field2": " 4kg",
                            "field3": "",
                            "field4": "",
                            "description": "Secco cane  4kg",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 14.100905562742561,
                                "left": 52.26390685640362,
                                "width": 11.901681759379045,
                                "height": 24.0620957309185
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/FRISKIES_Cane_Crocchette_Vitafit_Balance_con_Pollo_e_Verdure_10kg_1__yMOvgiS.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_O554qKJ_o1uX3k5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17609653",
                            "field1": "Biscotti",
                            "field2": "500g",
                            "field3": "",
                            "field4": "",
                            "description": "Biscotti 500g",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 14.100905562742561,
                                "left": 64.55368693402329,
                                "width": 11.901681759379045,
                                "height": 24.0620957309185
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/friskies_NHpd7c6.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_FMmUx6F_eqXY4ya.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49024838",
                            "field1": "Secco gatto",
                            "field2": "2kg",
                            "field3": "",
                            "field4": "",
                            "description": "Secco gatto 2kg",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 14.359637774902977,
                                "left": 76.58473479948253,
                                "width": 15.782664941785251,
                                "height": 24.0620957309185
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/friskiesGatto_Zl3h1vl.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_T6H8TlI_EG3jHxc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm56621294",
                            "field1": "MIGLIORCANE I PREFERITI",
                            "field2": "1,5 kg ",
                            "field3": "Crocchette: Pollo e Riso, Manzo",
                            "field4": "",
                            "description": "MIGLIORCANE I PREFERITI 1,5 kg  Crocchette: Pollo e Riso, Manzo",
                            "grammage": null,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pollo e Riso",
                                "Manzo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 39.197930142302724,
                                "left": 51.22897800776196,
                                "width": 12.419146183699871,
                                "height": 25.226390685640368
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/MIGLIORCANE-I-PREFERITI-SENIOR-CROCCHETTE-CON-MANZO-E-AVENA-GR3000--_xsx9BrH.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_9sphd7y_mwwLq5F.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm36946146",
                            "field1": "MIGLIORCANE I PREFERITI 2,5 kg",
                            "field2": "crocchette: ",
                            "field3": "Manzo e Avena, Salmone",
                            "field4": "",
                            "description": "MIGLIORCANE I PREFERITI 2,5 kg crocchette:  Manzo e Avena, Salmone",
                            "grammage": 2500,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Manzo e Avena",
                                "Salmone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 39.06856403622251,
                                "left": 64.68305304010349,
                                "width": 14.877102199223803,
                                "height": 25.226390685640368
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/s_seniorMA_2-5kg_uaN8GK0.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_oK1VbLd_a2ZFst2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28589633",
                            "field1": "MIGLIORCANE I PREFERITI",
                            "field2": "3KG",
                            "field3": "crocchette: pollo e riso",
                            "field4": "",
                            "description": "MIGLIORCANE I PREFERITI 3KG crocchette: pollo e riso",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "pollo e riso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 39.06856403622251,
                                "left": 81.24191461836998,
                                "width": 11.384217335058215,
                                "height": 25.226390685640368
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/78084-fancybox_default_fUz2md4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_5oSO42O_Yy73tzR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60030212",
                            "field1": "CESAR ricette classiche",
                            "field2": "paté ",
                            "field3": "150g",
                            "field4": "",
                            "description": "CESAR ricette classiche paté  150g",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 64.42432082794308,
                                "left": 51.35834411384217,
                                "width": 10.737386804657179,
                                "height": 25.61448900388098
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/pate_xGX4mMO_qS0rAmh.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_5uV7oQg_XhDi2qS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/video/Cesar_-_Spot_2018.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm52039283",
                            "field1": "PEDIGREE",
                            "field2": "donastix small",
                            "field3": "snack 7 pezzi",
                            "field4": "",
                            "description": "PEDIGREE donastix small snack 7 pezzi",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 64.42432082794308,
                                "left": 62.354463130659774,
                                "width": 9.055627425614489,
                                "height": 25.61448900388098
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/pedigree-dentastix-snack-per-cani-small-5-10-kg_dm4AtXg.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_UbdGaQL_4fiyMjC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73487516",
                            "field1": "PEDIGREE",
                            "field2": "denastix medium",
                            "field3": "snack 7 pezzi",
                            "field4": "",
                            "description": "PEDIGREE denastix medium snack 7 pezzi",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 64.55368693402329,
                                "left": 72.3156532988357,
                                "width": 10.608020698576974,
                                "height": 25.61448900388098
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/medium_3sqiAZh.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_xgnsPRC_oDJZxrs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28009267",
                            "field1": "PEDIGREE",
                            "field2": "dentastix large ",
                            "field3": "snack 7 pezzi",
                            "field4": "",
                            "description": "PEDIGREE dentastix large  snack 7 pezzi",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 64.55368693402329,
                                "left": 83.3117723156533,
                                "width": 9.573091849935317,
                                "height": 25.61448900388098
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/large_QVKlCdS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_tuxdaCr_eZlcAth.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_8_krH4RVU.jpg",
                    "products": [
                        {
                            "item_id": "cstm26844737",
                            "field1": "SCOTTEX tutti i giorni",
                            "field2": "fazzoletti 2 veli ",
                            "field3": "12 pacchetti",
                            "field4": "",
                            "description": "SCOTTEX tutti i giorni fazzoletti 2 veli  12 pacchetti",
                            "grammage": null,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 7.61134606019122,
                                "left": 7.103922989511806,
                                "width": 28.16198042270752,
                                "height": 20.306964180818
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/scottex_5NlYL2w.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_vdIPOpe_TzkTjY1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44912941",
                            "field1": "SCOTTEX l'originale",
                            "field2": "carta igienica",
                            "field3": "10 rotoli",
                            "field4": "",
                            "description": "SCOTTEX l'originale carta igienica 10 rotoli",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 7.891332470892626,
                                "left": 35.70504527813714,
                                "width": 28.33117723156533,
                                "height": 20.181112548512292
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/carta_igienica_L1BlKDK.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_3nxXYtp_VWTGMYR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23122955",
                            "field1": "KLEENEX",
                            "field2": "the original",
                            "field3": "veline 70 pezzi",
                            "field4": "",
                            "description": "KLEENEX the original veline 70 pezzi",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 28.201811125485122,
                                "left": 7.373868046571799,
                                "width": 28.33117723156533,
                                "height": 20.181112548512292
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/kleenex_7hbEGnU.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_AIDPOrJ_khCK4q6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41613592",
                            "field1": "Fria easy",
                            "field2": "carta igienica umidificata",
                            "field3": "50 salviette",
                            "field4": "",
                            "description": "Fria easy carta igienica umidificata 50 salviette",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 48.64165588615783,
                                "left": 7.373868046571799,
                                "width": 28.33117723156533,
                                "height": 20.69857697283312
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/fria_J65LMRD.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_sZrk0gB_252fCEJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80776614",
                            "field1": "Speedy care",
                            "field2": "salviette",
                            "field3": "15 pezzi",
                            "field4": "",
                            "description": "Speedy care salviette 15 pezzi",
                            "grammage": null,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 69.59896507115135,
                                "left": 6.985769728331176,
                                "width": 22.380336351875805,
                                "height": 20.4398447606727
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/d_1ZX9Tn2.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/dd_s8VDbZn.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_BPpOjHY_KVYdb4P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60851239",
                            "field1": "Speedy care ",
                            "field2": "baby line",
                            "field3": "72 pezzi",
                            "field4": "",
                            "description": "Speedy care  baby line 72 pezzi",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 69.98706338939198,
                                "left": 30.012936610608026,
                                "width": 20.69857697283312,
                                "height": 20.051746442432083
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/Speedy-Care-salviette-babyline-bimbo-sensitive_AU5IesC.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_Pk3ewRH_Tqvv0xP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88094418",
                            "field1": "PAMPERS naturello",
                            "field2": "salviettine ",
                            "field3": "52 pezzi",
                            "field4": "",
                            "description": "PAMPERS naturello salviettine  52 pezzi",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 69.98706338939198,
                                "left": 51.099611901681754,
                                "width": 16.429495472186286,
                                "height": 20.051746442432083
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/salviettine_P3tUmb6.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_Jf8UrZd_IY0Ql7h.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16917248",
                            "field1": "PAMPERS naturello",
                            "field2": "pannolini assortiti",
                            "field3": "",
                            "field4": "",
                            "description": "PAMPERS naturello pannolini assortiti",
                            "grammage": null,
                            "price": "7.90",
                            "price_label": "€ 7,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 69.59896507115135,
                                "left": 68.17593790426909,
                                "width": 24.320827943078914,
                                "height": 20.310478654592494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/naturelloPacks_U4XJlt3.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_vzUvR8c_F8Gqhiv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11299628",
                            "field1": "Pants discreet",
                            "field2": "pannolini a mutandina incontinenza",
                            "field3": "large 7 pezzi medium 8 pezzi",
                            "field4": "",
                            "description": "Pants discreet pannolini a mutandina incontinenza large 7 pezzi medium 8 pezzi",
                            "grammage": null,
                            "price": "5.90",
                            "price_label": "€ 5,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 7.891332470892626,
                                "left": 64.29495472186288,
                                "width": 28.46054333764554,
                                "height": 17.33505821474774
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/51wYkwwP1lL._AC_SX466__Y2Gtvsq.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_nr9Iu7k_fySHQs9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63779634",
                            "field1": "pants plus",
                            "field2": "pannolini a mutandina incontinenza",
                            "field3": "large 8 pezzi medium 9 pezzi",
                            "field4": "",
                            "description": "pants plus pannolini a mutandina incontinenza large 8 pezzi medium 9 pezzi",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 25.355756791720573,
                                "left": 64.42432082794308,
                                "width": 14.230271668822773,
                                "height": 22.509702457956017
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/tena_pants_plus_large_QJmZzM9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_rm21Gt3_myHb1yN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60771768",
                            "field1": "pants culottes plus night",
                            "field2": "pannoloni a mutandina incontinenza",
                            "field3": "medium/large 12 pezzi",
                            "field4": "",
                            "description": "pants culottes plus night pannoloni a mutandina incontinenza medium/large 12 pezzi",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 25.355756791720573,
                                "left": 79.04269081500647,
                                "width": 13.842173350582152,
                                "height": 23.673997412677878
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/540-tena-pants-plus-night-2016_geBw4mG.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_VtphMrl_jjtS0HC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09813399",
                            "field1": "MEN",
                            "field2": "assorbenti incontinenza",
                            "field3": "light 12 pezzi medium 10 pezzi",
                            "field4": "",
                            "description": "MEN assorbenti incontinenza light 12 pezzi medium 10 pezzi",
                            "grammage": null,
                            "price": "4.90",
                            "price_label": "€ 4,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 48.51228978007762,
                                "left": 64.42432082794308,
                                "width": 13.583441138421739,
                                "height": 21.08667529107374
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/tena-men-level-1-light-incontinence-pads_Wl7WMxp.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_lQspyRn_vuCBzWT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88950319",
                            "field1": "men active fit ",
                            "field2": "pannoloni a mutandina incontinenza",
                            "field3": "large 8 pezzi medium 9 pezzi",
                            "field4": "",
                            "description": "men active fit  pannoloni a mutandina incontinenza large 8 pezzi medium 9 pezzi",
                            "grammage": null,
                            "price": "7.90",
                            "price_label": "€ 7,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 48.25355756791722,
                                "left": 78.39586028460545,
                                "width": 14.489003880983185,
                                "height": 21.08667529107374
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/51T8rxVh7jL._AC__Wqtz7dg.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/products/cropped_image_gTfg3Fu_LWfPL5i.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.tena.it/uomini/prodotti/mutandina-assorbente-maschile/tena-men-active-fit-pants"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_9_xmYzzbv.jpg",
                    "products": []
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_10_qgQk3Jj.jpg",
                    "products": []
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_11_WmVCRuF.jpg",
                    "products": []
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_12_DcdZfof.jpg",
                    "products": []
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_13_zc60TQC.jpg",
                    "products": []
                },
                {
                    "number": 14,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_14_ECGPLoD.jpg",
                    "products": []
                },
                {
                    "number": 15,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_15_QIHrPhh.jpg",
                    "products": []
                },
                {
                    "number": 16,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/page_16_RepDZ56.jpg",
                    "products": []
                },
                {
                    "number": 17,
                    "image_file": "https://interattivo.s3.amazonaws.com/lV3AVUF29O/pages/Fine_acquaesapone_UmCWKCJ.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.acquaesapone;
}

export const serverResponse = lefletSwitch();
